import { useEffect } from 'react';

import type { UseProductDirectoryEffectsProps } from '@app/pages/Warehouses/ProductDirectory/types';

export const useProductDirectoryEffects = ({
  searchProductsHandler,
}: UseProductDirectoryEffectsProps) => {
  useEffect(() => {
    searchProductsHandler();
  }, [searchProductsHandler]);
};
